import { PATH_ANALYTICS, TAB_ANALYTICS } from "constants/paths";
import { CONTACTS_INNER_ANALYTICS, CONTACT_ANALYTICS } from "constants/types";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import store from "store";
import { getQuarterDates, getQueryAccountId, getQueryParam } from "utils";
import { moveAppliedFiltersToSelected } from "../actions";
import { analyticsDatesFilterChange } from "../Dashboard/actions";
import { getConstantCampaignEmailId } from "../utils";

const DEFAULT_PAGE_LIMIT = 20;
export const CONTACTS_BY_FILTER_ENUM = {
  EQUALS: 1,
  LESS: 2,
  GREATER: 3,
  LESS_OR_EQUAL: 4,
  GREATER_OR_EQUAL: 5,
};

export const getSelectedLabel = (value: string) => {
  switch (value) {
    case "Unique Opens":
      return "UNIQUE_OPENS";
    case "Unique Clicks":
      return "UNIQUE_CLICKS";
    case "Total Opens":
      return "TOTAL_OPENS";
    case "Total Clicks":
      return "TOTAL_CLICKS";
  }
};
export const getDisplayLabel = (value: string) => {
  switch (value) {
    case "UNIQUE_OPENS":
      return "Unique Opens";
    case "UNIQUE_CLICKS":
      return "Unique Clicks";
    case "TOTAL_OPENS":
      return "Total Opens";
    case "TOTAL_CLICKS":
      return "Total Clicks";
  }
};
export const getSelectedType = (value: string) => {
  switch (value) {
    case "=":
      return 1;
    case "<":
      return 2;
    case ">":
      return 3;
    case "<=":
      return 4;
    case ">=":
      return 5;
  }
};
export const RedirectToContactDetails = (row: any, history: any) => {
  moveAppliedFiltersToSelected();
  const pathname = `${history.location.pathname}${history.location.search}`;
  store.dispatch({
    type: CONTACT_ANALYTICS.SELECTED_PERSON,
    payload: { selectedPerson: row },
  });
  const urlParts = window.location.pathname.split("/").reverse();
  const tab = urlParts[0] === "" ? urlParts[1] : urlParts[0];
  store.dispatch({ type: CONTACTS_INNER_ANALYTICS.RESET_CONTACT_DETAILS });
  store.dispatch({ type: CONTACT_ANALYTICS.SET_REDIRECT_URL, payload: { redirectUrl: pathname } });
  let url = `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/dashboard/?contact_id=${
    row.contacts_id !== undefined ? row.contacts_id : row.contact_id
  }`;
  let campaign_id = getQueryParam("campaign_id");
  let email_id = getQueryParam("email_id");
  if (campaign_id && email_id) url += `&campaign_id=${campaign_id}&email_id=${email_id}`;
  history.push(url);
};

export const getPagination = (tab: string, params?: any) => {
  let analyticsDashboard = store.getState().analyticsDashboard;
  let analyticsGraph = store.getState().analyticsGraph;
  let { appliedCampaignIds, appliedAssetsIds, excludeCampaignsIds, excludeAssetsIds } = analyticsDashboard;
  let { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = analyticsDashboard.appliedCampaignsFilters;
  let { isAllCampaigns } = analyticsDashboard.appliedCampaignsFilters;
  let { startDate, endDate } = analyticsGraph;

  let campaignIds;
  let emailIds;
  let _params: any = {
    limit: DEFAULT_PAGE_LIMIT,
    tab: tab,
    searchWord: params.searchWord,
    offset: params.offset !== undefined ? params.offset : params.page > 0 ? params.data.length : 0,
    sortBy: params.sortBy,
    sortType: params.sortType,
  };
  if (isAllCampaigns) {
    _params["allCampaigns"] = true;
    _params["excludeCampaignsIds"] = excludeCampaignsIds;
    _params["excludeAssetsIds"] = excludeAssetsIds;
  } else {
    if (appliedCampaignIds.length <= 0 && getQueryCampaignId() > 0)
      campaignIds = appliedCampaignIds.length > 0 ? appliedCampaignIds : [];
    else campaignIds = appliedCampaignIds;
    if (appliedAssetsIds.length <= 0 && getQueryEmailId() > 0)
      emailIds = appliedAssetsIds.length > 0 ? appliedAssetsIds : [];
    else emailIds = appliedAssetsIds;
    _params["emailIds"] = emailIds;
    _params["campaignIds"] = campaignIds;
  }
  if (startDate === "" && endDate === "") {
    analyticsDatesFilterChange({ value: "qtr", label: "1 QTR" });
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    // analyticsDatesFilterChange({ value: "month", label: "Month" });
    // startDate = getMonthDates().start_date;
    // endDate = getMonthDates().end_date;
  }
  _params["startDate"] = startDate;
  _params["endDate"] = endDate;

  if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
    let email_campaign_id = getConstantCampaignEmailId({ isShareProfile, isDailyIQ, isWeeklyAccountInsights });
    _params["emailIds"] = [email_campaign_id];
    _params["campaignIds"] = [email_campaign_id];
  }

  if (params.contactsByFilter) _params["contactsByFilter"] = params.contactsByFilter;
  if (getQueryAccountId()) _params["accountId"] = getQueryAccountId();
  return _params;
};

export const ANALYTICS_DEFAULT_DATES_FILTER = { value: "qtr", label: "1 QTR" };
